import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/SponsoredTextOffers';
const SponsoredTextOffersRootActionPath = 'core/SponsoredTextOffers/GET';

export const SPONSORED_TEXT_OFFERS_GET_SUCCESS = `${SponsoredTextOffersRootActionPath}_${SUCCESS_SUFFIX}`;
export const SPONSORED_TEXT_OFFERS_GET_FAILURE = `${SponsoredTextOffersRootActionPath}_${FAILURE_SUFFIX}`;
export const SPONSORED_TEXT_VIEW = `${rootActionPath}/VIEW`;
